import { connect } from 'react-redux';
import { hidePSTN, showPSTN } from 'actions/JoinModal';
import AudioModeChooser from 'components/AudioModeChooser/AudioModeChooser';
import _get from 'lodash/get';

const mapStateToProps = state => ({
  PSTNMode: _get(state, 'app.joinModal.isPSTNVisible'),
});

const mapDispatchToProps = dispatch => ({
  showPSTN: () => {
    dispatch(showPSTN());
  },
  hidePSTN: () => {
    dispatch(hidePSTN());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AudioModeChooser);
